// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dow-picker.mb-3{border:none;padding:0}.dow-picker.mb-3 label{color:inherit;margin-left:.2rem}.dow-picker.mb-3 .invalid-feedback{display:none}.was-validated .dow-picker.mb-3.invalid .invalid-feedback{display:block}", ""]);
// Exports
module.exports = exports;
